import React, { useEffect, useState, FC } from 'react';

import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';

import { documentService, windowService } from '../../../../utils/window.utils';

const PageUrlField: FC<ValueFieldProps> = (props) => {
  const { field } = props;
  const [value, setValue] = useState(props.value);
  const id = field?.valueField?.id;
  const name = field?.valueField?.name;

  useEffect(() => {
    const url = windowService()?.btoa(encodeURIComponent(documentService().URL));

    setValue(url);
    props.onChange(field.valueField.name, url, props.isValid, []);
  }, []);

  return (
    <div>
      <input id={id} name={name} className="sitecore-jss-form__field" type="hidden" value={value} form="novalidatedform" />
    </div>
  );
};

export default PageUrlField;
